
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import WxHeader from './Header'

export default {
components: {
Tab,
TabItem,
Swiper,
SwiperItem,
WxHeader
},
data () {
return {
tag : '缴费中心',
no_payed_is_show: true,
payed_is_show: false,
type: '1',
PageIndex: 1,//页码从第一页开始
PageSize: 6,//煤业显示的条数
isShow: false,//是否显示scroller,第一次请求数据过程中隐藏插件，不隐藏的时候会显示“请上拉刷新数据”的字样，不好看
showloading: false,
textloading: '加载中',
showUp: true,
isbounce: false,
lists: [],
detail_row: [],
upobj: {
content: '请上拉刷新数据',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '请上拉刷新数据',
upContent: '请上拉刷新数据',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
},
isShowLoading: false,
textLoading: '加载中',
scrollerStatus: {
pullupStatus: 'default'
}
}
},
mounted () {

this.show_payed('no');
},
methods: {
show_payed(payed_type){
console.log(payed_type);
if(payed_type == 'yes'){
this.no_payed_is_show = false;
this.payed_is_show = true;

this.getNewsList(true)
this.$nextTick(() => {

})
}else{
this.no_payed_is_show = true;
this.payed_is_show = false;
this.getOrdersCurDetail();
}
},
getOrdersCurDetail(){
let _self = this;
let api_url = this.server_api_url+'service=get_orders_page_list&page=' + this.PageIndex + '&size=1';
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
return false;
}
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.data.list !== undefined && data_arr.data.list.length > 0){
_self.detail_row = data_arr.data.list;
}else if(data_arr.status != '1'){
_self.baseShowModuleAuto(data_arr.msg);
}



}).catch((response) =>{
console.log(response)
})
},
getNewsList(isEmpty){


let _self = this;

let api_url = this.server_api_url+'service=get_orders_history_list&page=' + this.PageIndex + '&size=' + this.PageSize;
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
return false;
}
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
let data_list = data_arr.data.list
if (isEmpty) {
_self.lists = []
_self.show = false
} else {

if (data_list && data_list.length === 0) {
_self.showToast = true
_self.isShowLoading = false
_self.scrollerStatus.pullupStatus = 'disabled' 
return
}
}
for (var i = 0; i < data_list.length; i++) {
_self.lists.push(data_list[i]);
}
_self.isShow = true;
_self.showloading = false
if(data_list.length < _self.PageSize){
_self.showToast = true
_self.isShowLoading = false
_self.scrollerStatus.pullupStatus = 'disabled' 
return
}
if (!isEmpty) {
_self.scrollerStatus.pullupStatus = 'default'
_self.$nextTick(() => {
_self.$refs.scroller.reset()
})
}


}).catch((response) =>{
_self.isShow = false
console.log(response)
})
},
selPullUp () {
this.PageIndex++
this.getNewsList(false)
},
}
}



// WEBPACK FOOTER //
// ./src/components/PaymentCenter.vue